const footerTab = Array.from(document.querySelectorAll(".tgtp-filter-footer-menu__tab"));
const headerTab = Array.from(document.querySelectorAll(".tgtp-filter-header__bottom--pc .tgtp-filter-menu__filter-menu"));
const headerTabSp = Array.from(document.querySelectorAll(".tgtp-filter-header__bottom--sp .tgtp-filter-menu__filter-menu"));
const headerSpMenu = document.querySelector(".tgtp-filter-header__bottom--sp");

footerTab.forEach((element, index) => {
  element.addEventListener('click', (e) => {
    if (window.matchMedia('(max-width: 749px;)')) {
      headerTabSp.forEach(element => {
        element.classList.remove("active");
        element.closest(".tgtp-filter-menu__tab-wrapper").classList.remove("active");
      });
      headerTabSp[index].classList.add("active");
      headerSpMenu.classList.add("active");
      headerTabSp[index].closest(".tgtp-filter-menu__tab-wrapper").classList.add("active");
    }
    if (window.matchMedia('(min-width: 750px;)')) {
      headerTab.forEach(element => {
        element.classList.remove("active");
        element.closest(".tgtp-filter-menu__tab-wrapper").classList.remove("active");
      });
      headerTab[index].classList.add("active");
      headerTab[index].closest(".tgtp-filter-menu__tab-wrapper").classList.add("active");
    }
    e.stopPropagation();
  });
});
